import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { defaultPagingChoices, paging } from "@/js/lists.ts";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { filterVAutocomplete } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import Paging from "@/components/paging/PagingComponent.vue";
import Index from "@/components/paging/IndexComponent.vue";
import ConditionalDiscountModal from "@/components/conditionaldiscount/ConditionalDiscountModal.vue";
import ConditionalDiscountV2Modal from "@/components/conditionaldiscount/ConditionalDiscountV2Modal.vue";
export default {
  name: "conditionalsDiscountsList",
  components: {
    Paging: Paging,
    Index: Index,
    Confirm: Confirm,
    ConditionalDiscountModal: ConditionalDiscountModal,
    ConditionalDiscountV2Modal: ConditionalDiscountV2Modal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      currentWineId: null,
      isConditionalDiscountModalShown: false,
      isLoading: false,
      isLoadingList: false,
      isLoadingWines: true,
      isLoadingWineries: true,
      formSearch: {
        paging: {
          limits: paging.DEFAULT,
          currentPage: 0,
          askedPage: 0
        },
        list_id_wines: [],
        list_id_wineries: []
      },
      numberOfPages: 0,
      conditionalDiscountCount: 0,
      fetchConditionalsDiscountsToken: null,
      listWines: [],
      listWineries: [],
      headers: [{
        text: "Product",
        value: "display_name"
      }, {
        text: "SKU",
        value: "accountancy_code"
      }, {
        text: "Actions",
        value: "action"
      }],
      items: [],
      defaultPagingChoices: defaultPagingChoices
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.isLoadingList && this.items.length > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this, filters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this = _this2;
            _this.isLoading = true;
            filters = getFilters();
            if (filters !== null && filters !== void 0 && filters.creditNotes) {
              _this.formSearch = _objectSpread(_objectSpread({}, _this.formSearch), filters.conditionalsDiscounts);
            }
            Promise.all([_this.fetchConditionalsDiscounts(), request("/v1/wines", "post", {
              paging: null,
              calculate_prices: false,
              only_display_names: true,
              bypassStockSeek: true,
              byPassPagingLimitation: true
            }, true, "api").then(function (response) {
              _this.listWines = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
              _this.isLoadingWines = false;
            }).catch(function () {
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            }), request("/v1/producers/all", "post", {}, true, "api").then(function (response) {
              _this.listWineries = _toConsumableArray(response.data.value.items);
              _this.isLoadingWineries = false;
            }).catch(function () {
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            })]).then(function () {
              _this.isLoading = false;
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
      }
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isResetPaging) this.resetPaging();
      this.fetchConditionalsDiscounts();
    },
    fetchConditionalsDiscounts: function fetchConditionalsDiscounts() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchCondition;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingList = true;
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  conditionalsDiscounts: _this3.formSearch
                });
              });
              (_this3$fetchCondition = _this3.fetchConditionalsDiscountsToken) === null || _this3$fetchCondition === void 0 || _this3$fetchCondition.cancel();
              _this3.fetchConditionalsDiscountsToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 7;
              return request("/v1/conditionals-discounts/all", "post", _this3.formSearch, true, "api", null, _this3.fetchConditionalsDiscountsToken).then(function (response) {
                _this.conditionalDiscountCount = response.data.value.total_number;
                _this.numberOfPages = Math.ceil(_this.conditionalDiscountCount / +_this.formSearch.paging.limits);
                _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
                _this.items = response.data.value.items.map(function (x) {
                  return _objectSpread({}, x);
                });
                _this.isLoadingList = false;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load the conditionals discounts.", {
                    type: "error"
                  });
                }
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openDiscounts: function openDiscounts() {
      var _this4 = this;
      this.isConditionalDiscountModalShown = true;
      this.$nextTick(function () {
        _this4.$refs.ConditionalDiscountV2Modal.open();
      });
    },
    closeDiscounts: function closeDiscounts() {
      var _this5 = this;
      this.isConditionalDiscountModalShown = false;
      this.$nextTick(function () {
        _this5.search(true);
      });
    },
    filterVAutocomplete: filterVAutocomplete
  }
};